import { gis2QueryUrl } from "../../utils/urls.js"

const boroughLayer = {
  layer: {
    id: "borough",
    type: "line",
    paint: {
      "line-color": "#000000",
      "line-width": 1,
    },
  },
  source: {
    id: "borough",
    type: "geojson",
    data: gis2QueryUrl("webmap_context_layer", 3),
  },
  filters: {
    filterByChildren: false,
  },
  labels: {
    parent: "Borough Boundaries",
  },
  orderNumber: 3,
  category: "planning",
  grouping: "boundaries",
  noColourPicker: true,
}

const highstreetLayer = {
  layer: {
    id: "highstreet",
    type: "fill",
    paint: {
      "fill-color": "#353d42",
      "fill-opacity": 0.5,
      "fill-outline-color": "#000000",
    },
  },
  source: {
    id: "highstreet",
    type: "geojson",
    data: gis2QueryUrl("Busyness_hs_tc_bid", 1, { where: "layer='highstreets'" }),
  },
  filters: {
    filterByChildren: false,
  },
  labels: {
    parent: "Highstreets",
  },
  isFocusAreaLayer: true,
  category: "planning",
  grouping: "boundaries",
  popupAttributes: ["name"],
  orderNumber: 0,
  info: {
    shortDescription:
      "Boundaries of High Streets as developed by the Regeneration team at the Greater London Authority.",
    longDescriptionTitle: "Highstreets Layer Information",
    longDescription:
      "Boundaries of High Streets as developed by the Regeneration team at the Greater London Authority. NOTE: these boundaries will be used when sharing data about High Street spend and visitor. They reflect the wider uses of High Streets including community, public and cultural, in addition to concentrations of retail units.",
  },
  noColourPicker: true,
}

const businessImprovementDistrictsLayer = {
  layer: {
    id: "business-improvement-districts",
    type: "fill",
    paint: {
      "fill-color": "#353d42",
      "fill-opacity": 0.5,
      "fill-outline-color": "#000000",
    },
    layout: {
      visibility: "none",
    },
  },
  source: {
    id: "business-improvement-districts",
    type: "geojson",
    data: gis2QueryUrl("Busyness_hs_tc_bid", 1, { where: "layer='bids'" }),
  },
  labels: {
    parent: "Business Improvement Districts",
  },
  filters: {
    filterByChildren: false,
  },
  isFocusAreaLayer: true,
  category: "planning",
  grouping: "boundaries",
  popupAttributes: ["name"],
  orderNumber: 1,
  info: {
    shortDescription:
      "A Business Improvement District (BID) is a geographical area in which the local businesses have voted to invest together to improve their environment.",
    longDescriptionTitle: "Business Improvement Districts Layer Information",
    longDescription:
      "BIDs provide additional or improved services, identified by the local businesses. This could include extra safety, cleaning or environmental measures. BIDs are business-led organisations. They’re funded by a mandatory levy on all eligible businesses after a successful ballot.",
  },
}

const townCentreBoundariesLayer = {
  layer: {
    id: "town-centre-boundaries",
    type: "fill",
    paint: {
      "fill-color": "#353d42",
      "fill-opacity": 0.5,
      "fill-outline-color": "#000000",
    },
    layout: {
      visibility: "none",
    },
  },
  source: {
    id: "town-centre-boundaries",
    type: "geojson",
    data: gis2QueryUrl("Busyness_hs_tc_bid", 1, { where: "layer='towncentres'" }),
  },
  labels: {
    parent: "Town Centre Boundaries",
  },
  filters: {
    filterByChildren: false,
  },
  isFocusAreaLayer: true,
  category: "planning",
  grouping: "boundaries",
  popupAttributes: ["name"],
  orderNumber: 4,
  info: {
    shortDescription:
      "Town centres provide a range of commercial, cultural and civic activities.",
    longDescriptionTitle: "Town Centre Boundaries Layer Information",
    longDescription:
      "Town centres provide a range of commercial, cultural and civic activities, including shopping, leisure, employment, entertainment, culture, and social and community facilities. Their vitality and viability should be promoted to ensure they retain their importance. There are five broad types of town centres according to their scales and roles: International centres, Metropolitan centres, Major centres, District centres and Neighbourhood and more local centres.",
  },
}

const cazLayer = {
  layer: {
    id: "caz",
    type: "line",
    paint: {
      "line-color": "#000000",
    },
    layout: {
      visibility: "none",
    },
  },
  source: {
    id: "caz",
    type: "geojson",
    data: gis2QueryUrl("planning_data_map_02", 107),
  },
  labels: {
    parent: "Central Activities Zone",
  },
  filters: {
    filterByChildren: false,
  },
  filterBySelectedRegion: false,
  category: "planning",
  grouping: "boundaries",
  orderNumber: 2,
  info: {
    shortDescription:
      "The Central Activities Zone covers London’s geographic, economic and administrative core.",
    longDescriptionTitle: "Central Activities Zone Layer Information",
    longDescription:
      "The Central Activities Zone covers London’s geographic, economic and administrative core. It’s unique combination of uses should be promoted and enhanced while also improving its environment and attractiveness for residents, visitors and businesses alike.",
  },
  noColourPicker: true,
}

export const planningLayerDefsBoundaries = {
  borough: boroughLayer,
  highstreet: highstreetLayer,
  "business-improvement-districts": businessImprovementDistrictsLayer,
  "town-centre-boundaries": townCentreBoundariesLayer,
  caz: cazLayer,
}
